import { useState } from 'react'

import { useCurrentShopQuery } from '@modules/Dashboard/hooks/useCurrentShopQuery'
import { useDnsQuery } from '@modules/Dashboard/hooks/useDnsQuery'

import { useEntri } from '../../../hooks/useEntri'

type UseCheckDomainProps = {
  onConnect?: () => void
}

const DNS_REFETCH_INTERVAL = 5_000

export const useCheckDomain = (options?: UseCheckDomainProps) => {
  const { currentShopQuery } = useCurrentShopQuery()
  const { connectDomain } = useEntri()

  const [isLoading, setIsLoading] = useState(false)
  const [isQueryEnabled, setIsQueryEnabled] = useState(false)

  useDnsQuery([], {
    refetchInterval: DNS_REFETCH_INTERVAL,
    enabled: isQueryEnabled,
    onSuccess: (dns) => {
      if (!dns || !dns.dnsList || !currentShopQuery.data || !isQueryEnabled) return

      const isEveryRecordValueLoaded = dns.dnsList.list.every((record) => record.value != null)

      if (!isEveryRecordValueLoaded) return

      setIsQueryEnabled(false)

      connectDomain(dns.dnsList, options?.onConnect)
    },
  })

  return {
    isLoading,
    setIsLoading,
    setIsQueryEnabled,
  }
}
